/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Explainer_TakeoverInputs */



/**
* | output |
* | --- |
* | "If another device takes over or unlocks the event, changes not yet uploaded are lost for good." |
*
* @param {Offline_Explainer_TakeoverInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_explainer_takeover = /** @type {((inputs?: Offline_Explainer_TakeoverInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Explainer_TakeoverInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si un autre appareil prend la main ou déverrouille le tournoi, les modifications pas encore envoyées sont définitivement perdues.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Si otro dispositivo toma el control o desbloquea el torneo, los cambios aún no subidos se pierden para siempre.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Se outro dispositivo assumir ou desbloquear o torneio, as mudanças ainda não enviadas se perdem para sempre.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Se un altro dispositivo prende il controllo o sblocca il torneo, le modifiche non ancora inviate vanno perse per sempre.")
	return /** @type {LocalizedString} */ ("If another device takes over or unlocks the event, changes not yet uploaded are lost for good.")
});